import * as React from "react";

import "./HomePage.scss";
import classNames from "classnames";
import { Header } from "../../components/Header";
import Footer from "../../components/Footer";
import { HeroVideo } from "./HeroVideo";
import { HomeCTA } from "./HomeCTA";
import { Accolades } from "../media/Accolades";
import { VideoSection } from "../../components/VideoSection";
import PlaceholderImage from "../../img/video_placeholder_@2x.png";
import { TeaserStateContext } from "../../util/app-state";
import { HeroLiveStream } from "./HeroLiveStream";

interface IHomePageProps {}

export const HomePage: React.FunctionComponent<IHomePageProps> = (props) => {
  const teaserState = React.useContext(TeaserStateContext);
  console.log(teaserState);
  return (
    <div className={classNames("HomePage")}>
      <Header />
      {teaserState.launch === "teaser" && <HeroVideo />}
      {teaserState.launch === "soft" && <HeroLiveStream />}
      <VideoSection
        video="https://jd-ces-2022.s3.amazonaws.com/00010_General_Teaser_4k_v20.mov.mp4"
        placeholder={PlaceholderImage}
        showPlayhead={true}
      />
      <HomeCTA />
      <Accolades title="Early Accolades" />
      <Footer />
    </div>
  );
};
